import config from '../utils/ApiUrl';
import { getCookie, handleSessionExpire } from './session';

const API_URL = config.API_URL;

const discountService = {
  getDiscounts: async () => {
    const sessionToken = getCookie();
    if (!sessionToken) return handleSessionExpire();

    const response = await fetch(`${API_URL}/discounts`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${sessionToken}`,
      },
    });
    const data = await response.json();
    return data.discounts;
  },

  deleteDiscount: async (id) => {
    const sessionToken = getCookie();
    if (!sessionToken) return handleSessionExpire();

    await fetch(`${API_URL}/discounts/${id}`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${sessionToken}`,
      },
    });
  },

  addDiscount: async (newDiscount) => {
    const sessionToken = getCookie();
    if (!sessionToken) return handleSessionExpire();

    const response = await fetch(`${API_URL}/discounts`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${sessionToken}`,
      },
      body: JSON.stringify(newDiscount),
    });
    const data = await response.json();
    return data.session ? handleSessionExpire() : data;
  },
};

export default discountService;
